module.exports = __webpack_public_path__ + "static/media/tt.c1a6db5b.svg";